import { createAction, createSelector, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import _ from 'lodash';
import api from 'lib/api';
import utils from 'lib/utils';
import storage from 'lib/storage';
import notifications from 'lib/notifications';
import { subscriptionService } from 'services';

const adapter = createEntityAdapter({});

const slice = createSlice({
  name: 'subscriptionDetails',
  initialState: adapter.getInitialState({
    busy: false,
  }),
  reducers: {
    setAll: adapter.setAll,
    addOne: adapter.addOne,
    addMany: adapter.addMany,
    updateOne: adapter.updateOne,
    updateMany: adapter.updateMany,
    upsertOne: adapter.upsertOne,
    upsertMany: adapter.upsertMany,
    removeOne: adapter.removeOne,
    removeMany: adapter.removeMany,
    removeAll: adapter.removeAll,
    setBusy(state, action) {
      let busy = action.payload;
      if (busy === false) {
        state.busy = false;
      } else {
        state.busy = true;
      }
    },
  },
});

const fetchDetails = (id) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    dispatch(slice.actions.removeAll());
    const resData = await subscriptionService.fetchDetails(id);
    dispatch(slice.actions.addOne(resData));
  } catch (err) {
    dispatch(slice.actions.addOne({}));
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const fetchUserSubscriptionDetails = () => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    dispatch(slice.actions.removeAll());
    const resData = await subscriptionService.fetchUserSubscriptionDetails();
    dispatch(slice.actions.setAll(resData));
  } catch (err) {
    dispatch(slice.actions.setAll({}));
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};
const fetchKycUserSubscriptionDetails = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    dispatch(slice.actions.removeAll());
    const resData = await subscriptionService.fetchKycUserSubscriptionDetails(params);
    dispatch(slice.actions.setAll(resData));
  } catch (err) {
    dispatch(slice.actions.setAll({}));
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const fetchUserSubscriptionPhaseTwoDetails = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    dispatch(slice.actions.removeAll());
    const resData = await subscriptionService.fetchUserSubscriptionPhaseTwoDetails(params);
    dispatch(slice.actions.setAll(resData));
  } catch (err) {
    dispatch(slice.actions.setAll({}));
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const actions = {
  ...slice.actions,
  fetchDetails,
  fetchUserSubscriptionDetails,
  fetchKycUserSubscriptionDetails,
  fetchUserSubscriptionPhaseTwoDetails,
};

const selectors = {
  ...adapter.getSelectors((state) => state.subscriptionDetails),
};

export { actions, selectors };

export default slice.reducer;
